import {
	type BackendPlacementMessage,
	type FrontendPlacementMessage,
	noValidation,
} from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import {
	type CreatePlacementMessageConfig,
	type BackendSyncMessageStage,
	type AnyPayload,
	type AnyBackendMessageStage,
	type AnyFrontendStage,
} from '@post-office/placement-common-v2/create-placement/types';
import { type TransformMetadataResult } from '@post-office/shared-contracts/message-template-metadata';

// Custom backend that fetches TCS hostname and TAP site trait to build the Confluence onboarding URL
export const MessageBackend: (config: CreatePlacementMessageConfig) => BackendPlacementMessage<{
	transformMetadata: BackendSyncMessageStage<AnyPayload, TransformMetadataResult>;
	hydrate?: AnyBackendMessageStage;
}> = PlacementBackend.createMessageBackend(() => ({
	transformMetadata: {
		validate: noValidation(),
		stage: () => ({}),
	},
	hydrate: {
		validate: assertMessageTemplateContext,
		stage: async ({ message, request }) => {
			const { logger, statsig } = request;
			const { messageInstanceId, messageTemplateId, triggerId } = message;
			const { cloudId: tenantId } = message.context;

			if (!tenantId || typeof tenantId !== 'string') {
				logger.error(
					{ messageInstanceId, messageTemplateId, triggerId },
					'Tenant ID not available',
				);
				throw new Error('Tenant ID not available');
			}

			statsig.getExperimentValue(
				{ identifiers: { tenantId } },
				{ name: 'twcg-991-jtbd-onboarding-a-a-fo', parameter: 'isEnabled', defaultValue: false },
			);

			throw Error('Control cohort - abort hydration');
		},
	},
}));

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: () => null,
	},
});
